const lineClampClassNames = {
    1: 'line-clamp-1',
    2: 'line-clamp-2',
    3: 'line-clamp-3',
    4: 'line-clamp-4',
    5: 'line-clamp-5',
    6: 'line-clamp-6',
}

const ClampedText = ({ as: Tag = 'p', lines = 2, title, className = '', children }) => (
    <Tag
        title={title || (typeof children === 'string' ? children : undefined)}
        className={`${lineClampClassNames[lines] || lineClampClassNames[2]} ${className}`}
    >
        {children}
    </Tag>
);

export default ClampedText;
